module.exports = "<span class=\"y-tooltip\" data-bind=\"event:{mouseenter:handleHover,mouseout: handleLeave}\">\n  <span class=\"fa fa-question-circle y-text-link\" data-bind=\"event:{mouseenter:handleHover},visible: question\"></span>\n  <span data-bind=\"text:title,event:{mouseenter:handleHover}\"></span>\n  <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n  <!-- ko if:!hasMarkup() -->\n  <y-tooltipctn params=\"fixHeight:fixHeight,targetEl:$el,title:title,show:isShow,position:position,height:height\"></y-tooltipctn>\n  <!-- /ko -->\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/tooltip/index.html
// module id = 491
// module chunks = 0